import React from 'react';

const Skills = ({ skills }) => {
	return (
		<ul>
			<li className="w-fit mb-3 flex flex-row justify-between items-center text-center">
				{skills.icon}
				<span>{skills.name}</span>
			</li>
		</ul>
	);
};

export default Skills;
